// removed by extract-text-webpack-plugin
module.exports = {"ripple":"theme__ripple___3cRG3","rippleWrapper":"theme__rippleWrapper___2AWhQ","rippleRestarting":"theme__rippleRestarting___y45XA","rippleActive":"theme__rippleActive___1QiQf"};


//////////////////
// WEBPACK FOOTER
// ./~/react-toolbox/lib/ripple/theme.scss
// module id = 1043
// module chunks = 0